import ApiService from '../service/ApiServiceFetch';
import MethodeService from '../service/MethodService';

let moduleApi = {};
let moduleName = "";

moduleApi.getPrefillId = (data) => {
    let objData = {
        method: "POST",
        url: window.MyConfig.surveyPath + "prefills/",
        params: {},
        data: data,
        type: "",
        message: {
            success: "",
            error: "",
        },
    };
    return ApiService(objData);
}

moduleApi.getFile = (id) => {
    let objData = {
        method: "GET",
        url: window.MyConfig.surveyPath + "mushroom_files/" + id,
        params: {},
        type: "",
        message: {
            success: "",
            error: ""
        }
    };
    return ApiService(objData);
}
export default moduleApi;